import React from 'react';
import { Box, Checkbox, Tooltip } from '@mui/material';

// Selects every flow of the list it is placed above. Aligned with the
// checkboxes of the rows below it.
const FlowSelectAll = ({ items, selectedFlows, toggleVisible }) => {
    if (!items.length) {
        return null;
    }

    const selectedCount = items.filter((item) => selectedFlows.some((flow) => flow.id === item.id)).length;

    return (
        <Box sx={{ paddingLeft: '16px' }}>
            <Tooltip title={
                <span style={{ fontSize: '1rem', lineHeight: '120%' }}>Select all flows of this list</span>
            } arrow>
                <Checkbox
                    checked={selectedCount === items.length}
                    indeterminate={selectedCount > 0 && selectedCount < items.length}
                    onChange={() => toggleVisible(items)}
                />
            </Tooltip>
        </Box>
    );
};

export default FlowSelectAll;
